var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76969 6.504H4.12569V6.132C4.12569 4.668 6.21369 4.692 6.21369 2.664C6.21369 1.296 5.22969 0.36 3.54969 0.36C1.86969 0.36 0.789688 1.296 0.789688 3.012V3.18H2.10969V3.012C2.10969 2.232 2.58969 1.536 3.53769 1.536C4.43769 1.536 4.85769 2.196 4.85769 2.808C4.85769 4.188 2.76969 4.128 2.76969 6.144V6.504ZM3.44169 9.12C3.87369 9.12 4.20969 8.796 4.20969 8.34C4.20969 7.884 3.87369 7.572 3.44169 7.572C3.00969 7.572 2.66169 7.884 2.66169 8.34C2.66169 8.796 3.00969 9.12 3.44169 9.12Z",
    fill: "#D4C7F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.dcc7667a35b5f90cb191598a06c2696a.svg";
export { ForwardRef as ReactComponent };